import React from 'react';
import i18n from '@i18n';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import MarketStatisticsHolder from '@/market-statistics';
import { fromJS } from 'immutable';
import BetLocationContext from 'nike-ui/src/common/BetLocationContext';
import useRemoveMarketStats from 'nike-ui/src/components/market-statistics/hooks/useRemoveMarketStats';
import useMatchMarketStats from 'nike-ui/src/components/market-statistics/hooks/useMatchMarketStats';

function BetbookStatisticsDialog({ matchId, sportId, sportEvent, market, sectionOrigin }) {
    const marketStatsSize = useMatchMarketStats(matchId, false);
    useRemoveMarketStats(matchId);
    return (
        <BetLocationContext.Provider value={{ betLocationSection: sectionOrigin }}>
            <Docked>
                <DialogTitle className="text-center text-extra-bold fs-24">
                    <h2 className="ml-32">
                        {i18n('betbook.statistics.dialog.title')}
                        <span className="fs-10 betbook-dialog-badge c-black-50 pl-5 ">{marketStatsSize}</span>
                    </h2>
                </DialogTitle>
                <DialogBody>
                    <MarketStatisticsHolder
                        sportId={sportId}
                        sportEvent={fromJS(sportEvent)}
                        market={market}
                        matchId={matchId}
                    />
                </DialogBody>
            </Docked>
        </BetLocationContext.Provider>
    );
}

export default BetbookStatisticsDialog;
